/**
 * Entries layout route — /entries
 *
 * Thin layout that renders its child route via <Outlet/>:
 * - exact /entries        → entries.index.tsx (the list)
 * - /entries/$id          → entries.$id.tsx (create/edit form)
 *
 * Without this Outlet the nested /entries/$id form has nowhere to render
 * (the list would stay mounted and the form would never appear).
 *
 * Protected by the _app.tsx beforeLoad auth guard.
 */
import { createFileRoute, Outlet } from '@tanstack/react-router';

function EntriesLayout() {
  return <Outlet />;
}

export const Route = createFileRoute('/_app/entries')({
  component: EntriesLayout,
});
